import { keyframes } from '@emotion/react';
import { get, Theme, ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const dropzone: ThemeUICSSObject = {
  backgroundSize: '200% 200%',
  display: 'flex',
  flex: '1',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: spacing(4),

  border: '1px solid',
  borderColor: 'dropzone.borderColor',

  '&:disabled': {
    cursor: 'not-allowed',
  },

  backgroundImage: (t: Theme) =>
    `repeating-linear-gradient( 45deg, ${
      get(t, 'colors.dropzone.color') as string
    }, ${get(t, 'colors.dropzone.color') as string} 3px, ${
      get(t, 'colors.dropzone.backgroundColor') as string
    } 3px, ${get(t, 'colors.dropzone.backgroundColor') as string} 12px )`,

  ':hover': {
    cursor: 'pointer',
    animation: `${keyframes({
      '100%': { backgroundPosition: '100% 100%' },
    })} 20s linear infinite`,

    '&:disabled': { animation: 'none' },
  },

  ':focus': {
    outlineColor: 'outlineColor',
    outlineWidth: '3px',
    outlineOffset: '-3px',
    outlineStyle: 'solid',
    borderColor: 'transparent',
  },
  /* PREPEND HERE */
};

export default dropzone;
